export default "__VITE_ASSET__CBQKrURq__"